import React, { ChangeEvent } from 'react';
import { Button, InputAdornment, TextField } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import OtpInput from '../../Components/OtpInput/OtpInput';

import './Login.css';
import banner from '../../Images/EASALY_color_stacked.png'
import ValidationCheck from '../../Common/Validation/ValidationChecks';
import { loadFromLocalStorage, saveToLocalStorage } from '../../Common/Validation/LocalStorage';
import { ShowAlert } from '../../Components/ShowAlert';
import LoginServices from '../../Services/LoginServices';
import ProfileServices from '../../Services/ProfileServices';




interface LoginProps { }
interface LoginState {
    email: string;
    otp: string;
    showOTPView: boolean;
    isEmailfocussed: boolean;
    isOtpFocussed: boolean;
    isOtpFailed: boolean;
    logo: string;
    tenantName: string;
    resendSeconds: number;
}

const OTP_LENGTH = 6;
const RESEND_WAIT_SECONDS = 30;


class Login extends React.Component<LoginProps, LoginState> {

    /** Prevents sending the OTP twice (e.g. Enter pressed repeatedly) while a request is in progress. */
    private isSendingOtp = false;
    private resendTimer?: ReturnType<typeof setInterval>;

    componentWillUnmount() {
        this.stopResendTimer();
    }

    constructor(props: LoginProps) {
        super(props);
        this.state = {
            email: '',
            otp: '',
            showOTPView: false,
            isEmailfocussed: false,
            isOtpFocussed: false,
            isOtpFailed: false,
            resendSeconds: 0,
            logo: '',
            tenantName: '',
        }
    }

    async componentDidMount() {
        const accesstoken = await loadFromLocalStorage('accessToken');

        if (accesstoken) {
            this.getUserDetails(accesstoken.toString());
        }

        const tenantData = JSON.parse(localStorage.getItem('TENANT_CONFIG') || '{}');
        const mainLogo = tenantData?.assets?.find(
            (x: string) => x.indexOf('admin_main_logo.png') !== -1
        );
        this.setState({
            tenantName: tenantData?.tenant_name
        });
        if (mainLogo) {
            this.setState({
                logo: mainLogo
            });
        }
    }

    public render() {
        return (
            <div className='login-parent-container'>
                <form className="login-container" id="userDetails" onSubmit={(event) => {
                    event.preventDefault();
                    // Enter key: same as clicking Continue / Send OTP for the current step
                    if (this.state.showOTPView) {
                        this.verifyOtp();
                    }
                    else {
                        this.sendOtp();
                    }
                }}>
                    <div className="imgcontainer">
                        <img src={this.state.logo} alt="Avatar" className="avatar" />
                    </div>
                    <div className='login-title'>Sign in</div>
                    <div className='login-sub-header'>Sign in to access your account</div>
                    <div className="login-form-body">
                        <div className='login-email-container'>
                            <div style={{ display: 'flex', flexDirection: 'column', padding: '10px 30px 10px 30px' }}>
                                {
                                    this.state.showOTPView ? <>
                                        <label className='login-field-label'>
                                            Enter verification code:
                                        </label>
                                        <OtpInput
                                            value={this.state.otp}
                                            length={OTP_LENGTH}
                                            autoFocus
                                            hasError={this.state.isOtpFailed}
                                            onChange={otp => this.setState({ otp, isOtpFocussed: true, isOtpFailed: false })}
                                        />

                                        {
                                            (this.state.isOtpFailed) && <div className="error-msg"><WarningIcon /> The OTP you entered is invalid or has expired.</div>
                                        }

                                        <Button type='submit' className='login-submit-btn' fullWidth disabled={this.state.otp.length !== OTP_LENGTH}>
                                            Verify
                                        </Button>

                                        <div className='login-resend'>
                                            Didn't receive the code?{' '}
                                            {
                                                this.state.resendSeconds > 0 ?
                                                    <span className='login-resend-wait'>Resend in {this.state.resendSeconds}s</span> :
                                                    <button type='button' className='login-resend-link' onClick={() => this.resendOtp()}>Resend</button>
                                            }
                                        </div>

                                    </>
                                        :
                                        <>
                                            <label className='login-field-label' htmlFor='login-email'>
                                                Email Address
                                            </label>

                                            <TextField
                                                id='login-email'
                                                type='email'
                                                autoComplete='email'
                                                autoFocus
                                                placeholder='Your email *'
                                                variant="outlined"
                                                color="primary" // Use the primary color
                                                value={this.state.email}
                                                onChange={(text) => {
                                                    this.setState({ isEmailfocussed: true, email: text.target.value });
                                                }}
                                                InputProps={{
                                                    endAdornment: <InputAdornment position='end'><MailOutlineIcon /></InputAdornment>
                                                }}
                                                className='login-input'
                                            />

                                            {
                                                (this.state.isEmailfocussed && this.state.email != "" && !ValidationCheck.validateEmail(this.state.email)) && <div className="error-msg"><WarningIcon /> Please enter the valid email address</div>
                                            }

                                            {
                                                (this.state.isEmailfocussed && this.state.email == "") && <div className='error-msg'><WarningIcon /> Please enter the email</div>
                                            }


                                            <Button type='submit' className='login-submit-btn' fullWidth disabled={!ValidationCheck.validateEmail(this.state.email)}>
                                                Send OTP &rarr;
                                            </Button>

                                            {/* <BigButton
                                                disabled={false}
                                                onClick={() => {
                                                    const postData = {
                                                        email: this.state.email,
                                                        otp: this.state.otp
                                                    }

                                                    LoginServices.penTestingLogin().then(response => {
                                                        if (response.ok) {
                                                            return response.json();
                                                        } else {
                                                            throw new Error("Network response was not ok.");
                                                        }
                                                    })
                                                        .then(async data => {
                                                            const accessToken = data.accessToken;
                                                            console.log(accessToken);
                                                            saveToLocalStorage('accessToken', accessToken);
                                                            const LoadAccesstoken = await loadFromLocalStorage('accessToken');
                                                            console.log("LoadAccesstoken", LoadAccesstoken);
                                                            this.getUserDetails(accessToken.toString());

                                                            // window.location.href = '/dashboard';
                                                            // You can now use the accessToken as needed
                                                        })
                                                        .catch(error => {
                                                            console.error("There was a problem with the fetch operation:", error);
                                                        });

                                                }} buttonText="Open Authentication" /> */}

                                        </>
                                }
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        )
    }

    private sendOtp() {
        if (this.isSendingOtp) {
            return;
        }
        if (!ValidationCheck.validateEmail(this.state.email)) {
            // Shows the email validation message when Enter is pressed with an invalid/empty email
            this.setState({ isEmailfocussed: true });
            return;
        }
        const postData = {
            email: this.state.email
        }
        this.isSendingOtp = true;
        LoginServices.sendOTP(postData).then(response => {
            if (response.ok) {
                this.setState({ showOTPView: true, otp: '', isOtpFailed: false });
                this.startResendTimer();
            } else {
                ShowAlert(this.state.tenantName, `Unable to send OTP to this email address ${this.state.email}`, 'error')
            }
        }).finally(() => {
            this.isSendingOtp = false;
        });
    }

    private resendOtp() {
        if (this.isSendingOtp || this.state.resendSeconds > 0) {
            return;
        }
        this.isSendingOtp = true;
        LoginServices.sendOTP({ email: this.state.email }).then(response => {
            if (response.ok) {
                this.setState({ otp: '', isOtpFailed: false });
                this.startResendTimer();
                ShowAlert(this.state.tenantName, "The OTP has been resent", 'success');
            } else {
                ShowAlert(this.state.tenantName, "Something went wrong", 'error');
            }
        }).finally(() => {
            this.isSendingOtp = false;
        });
    }

    private startResendTimer() {
        this.stopResendTimer();
        this.setState({ resendSeconds: RESEND_WAIT_SECONDS });
        this.resendTimer = setInterval(() => {
            const remaining = this.state.resendSeconds - 1;
            this.setState({ resendSeconds: Math.max(0, remaining) });
            if (remaining <= 0) {
                this.stopResendTimer();
            }
        }, 1000);
    }

    private stopResendTimer() {
        if (this.resendTimer) {
            clearInterval(this.resendTimer);
            this.resendTimer = undefined;
        }
    }

    private verifyOtp() {
        if (this.state.otp.length !== OTP_LENGTH) {
            this.setState({ isOtpFocussed: true });
            return;
        }
        const postData = {
            email: this.state.email,
            otp: this.state.otp
        }

        LoginServices.verifyOTP(postData).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                this.setState({ isOtpFailed: true });
            }
        })
            .then(async data => {
                if (!data) {
                    return;
                }
                const accessToken = data.accessToken;
                saveToLocalStorage('accessToken', accessToken);
                this.getUserDetails(accessToken.toString());
            })
            .catch(error => {
                console.error("There was a problem with the fetch operation:", error);
            });
    }

    private getUserDetails(accessToken: string) {
        ProfileServices.getUserDetails(accessToken).then(r => {
            if (r.ok) {
                r.json().then(resp => {
                    saveToLocalStorage('profile', resp);
                    window.location.href = '/dashboard'

                });
            }
            else {
                localStorage.clear();
            }
        });
    }
}
export default Login;